import { TFunction } from "i18next";

import { AuditLogEvents } from "../../enums";
import {
  AUDIT_LOG_SERVICE_DISPLAY_NAMES,
  AUDIT_LOG_SYSTEM_SERVICE_NAMES,
} from "./audit-log.constants";
import type { IAuditLogCauserInfo } from "./audit-log.models";

export const isSystemAuditLogCauser = (
  auditLog: IAuditLogCauserInfo,
): boolean =>
  auditLog.causerType === "System" ||
  AUDIT_LOG_SYSTEM_SERVICE_NAMES.has(auditLog.causerName);

export const getAuditLogCauserDisplayName = (
  auditLog: IAuditLogCauserInfo,
  translationFn?: TFunction,
): string => {
  if (!isSystemAuditLogCauser(auditLog)) {
    return auditLog.causerName;
  }

  const serviceKey = auditLog.service || auditLog.causerName;
  const i18nKey = `auditLog.service.${serviceKey}`;

  if (translationFn) {
    const translated = translationFn(i18nKey);
    if (translated !== i18nKey) {
      return translated;
    }
  }

  return (
    AUDIT_LOG_SERVICE_DISPLAY_NAMES[serviceKey] ?? auditLog.causerName ?? ""
  );
};

/**
 * Get emoji for audit log event type
 */
export const getEventEmoji = (eventNameValue: string): string => {
  switch (eventNameValue) {
    case AuditLogEvents.EntityCreated:
      return "✨";
    case AuditLogEvents.EntityUpdated:
      return "📝";
    case AuditLogEvents.EntityDeleted:
      return "🗑️";
    default:
      return "";
  }
};

/**
 * Get display name for audit log event type
 */
export const getEventDisplayName = (eventNameValue: string): string => {
  switch (eventNameValue) {
    case AuditLogEvents.EntityCreated:
      return "Entity created";
    case AuditLogEvents.EntityUpdated:
      return "Entity updated";
    case AuditLogEvents.EntityDeleted:
      return "Entity deleted";
    default:
      return "";
  }
};
